import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/submissions/components/SubmissionsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppLayout.tsx");
